import React from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Images, useModal } from 'utils';
import { appointmentActions } from 'store';
import { linksNotYet } from './constants';
import { AddCircleBlue, CustomDelete, EditWithIcon, NoItemsYet } from 'components';
import { LinksModal } from './linksModal';

const ACTION_TYPE = 'ADD_APPOINTMENT_LINK';
export const ScheduleLinks = ({ item }) => {
    const { open } = useModal();
    const dispatch = useDispatch();
    const links = item?.links?.filter((i) => i?.title !== 'Zoom') || [];

    const handleCopy = (link) => {
        navigator.clipboard.writeText(link).then(() => {
            toast('Link copied to clipboard');
        });
    };

    const handleDelete = (it) => {
        open(
            <CustomDelete
                text="Are you sure you want to delete the link?"
                info="Delete Link?"
                handleDel={() =>
                    dispatch(
                        appointmentActions.addApptLink(
                            item?.links?.filter((i) => i?._id !== it?._id),
                            item?.id
                        )
                    )
                }
                actionType={ACTION_TYPE}
                innerText={'Delete'}
                body={
                    <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                        <img style={{ marginTop: '3px' }} src={Images.externalLink} alt="icon" />
                        <p style={{ fontWeight: 400 }}>{it?.title}</p>
                    </div>
                }
            />
        );
    };

    return (
        <div className="full-width">
            <>
                <div className="space-between">
                    <p className="attached-link-body-title">Links</p>
                    <AddCircleBlue type="button" handleClick={() => open(<LinksModal />)} text={'Add Link'} />
                </div>
                {links?.length ? (
                    <div className="attached-link-body">
                        {links?.map((i, j) => (
                            <div key={j} className="link-line-box" style={{ marginBottom: 8, width: '49%' }}>
                                <a key={j} target={'_blank'} rel="noopener noreferrer" href={i?.url} className="attached-link-name">
                                    <img src={Images.linkIcon} alt="icon" />
                                    <p> {i?.title}</p>
                                </a>

                                <div className="flex-align-center" style={{ gap: 8 }}>
                                    <EditWithIcon
                                        icon={Images.externalLink}
                                        handleClick={() => window.open(i?.url, '_blank', 'noopener,noreferrer')}
                                    />
                                    <EditWithIcon icon={Images.editDarkBlue} handleClick={() => open(<LinksModal link={i} />)} />
                                    <EditWithIcon icon={Images.copy} handleClick={() => handleCopy(i?.url)} />
                                    <EditWithIcon icon={Images.redTrash} handleClick={() => handleDelete(i)} />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <NoItemsYet
                        height={linksNotYet?.height}
                        text={linksNotYet.title}
                        subTitle={linksNotYet.subTitle}
                        image={linksNotYet.image}
                    />
                )}
            </>
        </div>
    );
};
